import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';

import '../langhout-beton-order-setup/langhout-beton-order-setup';
import '../langhout-beton-order-start-loading/langhout-beton-order-start-loading';
import '../langhout-beton-retour-orders/langhout-beton-retour-orders';
import '../langhout-beton-order-cleanup/langhout-beton-order-cleanup';
import '../langhout-beton-automatic-stock-counts/langhout-beton-automatic-stock-counts';
import { factoryIcon } from '../../elements/icons/icons';

@customElement('langhout-beton-home')
export class LanghoutBetonHome extends LitElement {
  static styles = css`
    .bottom-space {
      height: 60px;
    }
    .factory-button-wrapper {
      background-color: var(--menu-color);
      position: absolute;
      width: 60px;
      height: 60px;
      left: 25px;
      bottom: 25px;
      z-index: 998;
      padding: 5px;
      border-radius: 50%;

      box-shadow: 0px 0px 0px 1px var(--background-color);
      box-shadow:
        0.25rem 0.25rem 0.6rem rgba(0, 0, 0, 0.5),
        0 0.5rem 1.125rem rgba(75, 0, 0, 0.05);
    }

    svg {
      width: 25px;
      height: 25px;
    }

    .column {
      height: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  `;

  @property({ type: String })
  private lastPath = 'unknown';

  constructor() {
    super();
  }

  render() {
    return html`
      <div
        class="factory-button-wrapper"
        @click="${() => {
          window.location.href = '/stock-count';
        }}"
      >
        <div class="column">${factoryIcon()}</div>
      </div>
      <langhout-beton-automatic-stock-counts></langhout-beton-automatic-stock-counts>
      <langhout-beton-retour-orders></langhout-beton-retour-orders>
      <langhout-beton-order-start-loading></langhout-beton-order-start-loading>
      <langhout-beton-order-setup></langhout-beton-order-setup>
      <langhout-beton-order-cleanup></langhout-beton-order-cleanup>
      <div class="bottom-space"></div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-home': LanghoutBetonHome;
  }
}
